import { EnumNivelAcesso } from 'src/app/components/shared/enums/nivel-acesso.enum';
import { SigepeUserData } from '@sigepe/ngx-sigepe-seguranca';

type SigepeUserDataComEstrutura = SigepeUserData & {
    orgao?: { codigo?: number };
    upag?: { codigo?: number };
    uorg?: { codigo?: number };
};

export interface RestricaoFiltroCombos {
    orgaoDesabilitado: boolean;
    orgaoPreSelecionado: number | null;
    upagDesabilitado: boolean;
    upagPreSelecionado: number | null;
    uorgDesabilitado: boolean;
    uorgPreSelecionado: number | null;
    descricaoRestricao: string;
}

export class NivelAcessoUtil {
    static obterRestricaoCombos(usuarioLogado: SigepeUserDataComEstrutura | null): RestricaoFiltroCombos {
        if (!usuarioLogado || !usuarioLogado.nivelAcesso) {
            return {
                orgaoDesabilitado: false,
                orgaoPreSelecionado: null,
                upagDesabilitado: false,
                upagPreSelecionado: null,
                uorgDesabilitado: false,
                uorgPreSelecionado: null,
                descricaoRestricao: 'Sem restrições'
            };
        }

        const nivelAcesso = `${usuarioLogado.nivelAcesso.id}`;
        const codigoOrgao = usuarioLogado.orgao?.codigo ?? null;
        const codigoUpag = usuarioLogado.upag?.codigo ?? null;
        const codigoUorg = usuarioLogado.uorg?.codigo ?? null;

        // NIVEL 1: ORGAO
        if (nivelAcesso === EnumNivelAcesso.ORGAO.id) {
            return {
                orgaoDesabilitado: true,
                orgaoPreSelecionado: codigoOrgao,
                upagDesabilitado: false,
                upagPreSelecionado: null,
                uorgDesabilitado: false,
                uorgPreSelecionado: null,
                descricaoRestricao: `Acesso restrito ao órgão ${codigoOrgao}`
            };
        }

        // NIVEL 2: ORGAO_E_VINCULADOS (mesma lógica que ORGAO)
        if (nivelAcesso === EnumNivelAcesso.ORGAO_VINCULADOS.id) {
            return {
                orgaoDesabilitado: true,
                orgaoPreSelecionado: codigoOrgao,
                upagDesabilitado: false,
                upagPreSelecionado: null,
                uorgDesabilitado: false,
                uorgPreSelecionado: null,
                descricaoRestricao: `Acesso restrito ao órgão ${codigoOrgao} e vinculados`
            };
        }

        // NIVEL 3: UORG
        if (nivelAcesso === EnumNivelAcesso.UORG.id) {
            return {
                orgaoDesabilitado: true,
                orgaoPreSelecionado: codigoOrgao,
                upagDesabilitado: true,
                upagPreSelecionado: codigoUpag,
                uorgDesabilitado: true,
                uorgPreSelecionado: codigoUorg,
                descricaoRestricao: `Acesso restrito à UORG ${codigoUorg}`
            };
        }

        // NIVEL 4: UPAG
        if (nivelAcesso === EnumNivelAcesso.UPAG.id) {
            return {
                orgaoDesabilitado: true,
                orgaoPreSelecionado: codigoOrgao,
                upagDesabilitado: true,
                upagPreSelecionado: codigoUpag,
                uorgDesabilitado: false,
                uorgPreSelecionado: null,
                descricaoRestricao: `Acesso restrito à UPAG ${codigoUpag}`
            };
        }

        // NIVEL 7: UORG_SUBORDINADAS (mesma lógica que UORG)
        if (nivelAcesso === EnumNivelAcesso.UORG_SUBORDINADAS.id) {
            return {
                orgaoDesabilitado: true,
                orgaoPreSelecionado: codigoOrgao,
                upagDesabilitado: true,
                upagPreSelecionado: codigoUpag,
                uorgDesabilitado: true,
                uorgPreSelecionado: codigoUorg,
                descricaoRestricao: `Acesso restrito à UORG ${codigoUorg} e subordinadas`
            };
        }

        // NIVEL 5: GERAL (ou qualquer outro nível)
        return {
            orgaoDesabilitado: false,
            orgaoPreSelecionado: null,
            upagDesabilitado: false,
            upagPreSelecionado: null,
            uorgDesabilitado: false,
            uorgPreSelecionado: null,
            descricaoRestricao: 'Acesso geral - sem restrições'
        };
    }
}
